import React, { lazy, Suspense, useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "الة حاسبه";
const DESCRIPTION = "استخدم الآلة الحاسبة البسيطة عبر الإنترنت لإجراء العمليات الحسابية الأساسية مثل الجمع والطرح والضرب والقسمة بسهولة دون الحاجة إلى تحميل أي تطبيق. احصل على نتائج دقيقة وسريعة من أي جهاز، سواء كان موبايل أو حاسوب.";
const KEYWORDS = "آلة حاسبة بسيطة, آلة حاسبة على الإنترنت, حسابات أساسية, آلة حاسبة مجانية, عمليات حسابية, أدوات حسابية عبر الإنترنت";
const OG_URL = "https://do-calculate.com/ar/calculators/";
const MathCalculator = lazy(() => import("./NormalCalculator"));
const ScientificCalculator = lazy(() => import("./ScientificCalculator"));
function Calculators() {
  // Changed default from 'normal' to 'scientific'
  const [activeTab, setActiveTab] = useState('scientific');
  const tabContainerStyle = {
    display: 'flex',
    gap: '8px',
    marginBottom: '0',
    padding: '8px',
    background: '#f8f9fa',
    borderRadius: '12px 12px 0 0'
  };
  const getTabButtonStyle = (isActive) => ({
    flex: 1,
    padding: '14px 20px',
    cursor: 'pointer',
    border: '2px solid transparent',
    background: isActive
      ? 'linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%)'
      : '#ffffff',
    color: isActive ? '#ffffff' : '#1a5f3f',
    textAlign: 'center',
    fontWeight: isActive ? '700' : '600',
    borderRadius: '10px',
    margin: '0',
    transition: 'all 0.3s ease',
    boxShadow: isActive
      ? '0 4px 12px rgba(26, 95, 63, 0.25)'
      : '0 2px 6px rgba(0, 0, 0, 0.08)',
    transform: isActive ? 'translateY(-2px)' : 'translateY(0)',
    fontFamily: "'Tajawal', sans-serif"
  });
  const tabContentStyle = {
    padding: '20px',
    background: '#ffffff',
    borderRadius: '0 0 12px 12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <p>
            مرحبًا بكم في موقع الآلة الحاسبة على الإنترنت! هنا نقدم لكم أدوات حسابية مصممة لتلبية احتياجاتكم المختلفة من العمليات الحسابية. سواء كنت تحتاج إلى إجراء حسابات بسيطة أو معقدة، لدينا الحل المثالي لك.
          </p>
          <p>
            باستخدام الآلة الحاسبة العادية، يمكنك بسهولة إتمام العمليات الحسابية اليومية مثل الجمع والطرح والضرب والقسمة، مما يجعلها أداة مثالية للاستخدام اليومي. أما إذا كنت تحتاج إلى أدوات حسابية أكثر تقدماً، فإن الآلة الحاسبة العلمية توفر لك وظائف متقدمة تشمل حسابات المثلثات، اللوغاريتمات، والنسب المئوية، وغيرها من العمليات المعقدة. كل ذلك متاح لك بكل سهولة عبر الإنترنت، دون الحاجة لتحميل أي تطبيقات، مما يضمن لك سهولة الوصول والراحة في أي وقت ومن أي مكان.
          </p>
          <p>
            استمتع بتجربة حسابية سلسة ودقيقة مع أدواتنا المجانية والمباشرة، وابدأ في إجراء حساباتك اليوم بكل كفاءة وسرعة!
          </p>
          <MobileUnderCalAds />
          <div className="border border-light" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <div className="row">
              <div style={tabContainerStyle}>
                <button
                  style={getTabButtonStyle(activeTab === 'scientific')}
                  onClick={() => setActiveTab('scientific')}
                  onMouseEnter={(e) => {
                    if (activeTab !== 'scientific') {
                      e.target.style.background = '#f0f7f4';
                      e.target.style.borderColor = '#1a5f3f';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== 'scientific') {
                      e.target.style.background = '#ffffff';
                      e.target.style.borderColor = 'transparent';
                    }
                  }}
                >
                  <h2 style={{ fontSize: '16px', margin: 0 }}>
                    حاسبة علمية
                  </h2>
                </button>
                <button
                  style={getTabButtonStyle(activeTab === 'normal')}
                  onClick={() => setActiveTab('normal')}
                  onMouseEnter={(e) => {
                    if (activeTab !== 'normal') {
                      e.target.style.background = '#f0f7f4';
                      e.target.style.borderColor = '#1a5f3f';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== 'normal') {
                      e.target.style.background = '#ffffff';
                      e.target.style.borderColor = 'transparent';
                    }
                  }}
                >
                  <h2 style={{ fontSize: '16px', margin: 0 }}>
                    حاسبة عادية
                  </h2>
                </button>
              </div>
              <div style={tabContentStyle}>
                {activeTab === 'scientific' && (
                  <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px', color: '#1a5f3f' }}>جاري التحميل...</div>}>
                    <ScientificCalculator />
                  </Suspense>
                )}
                {activeTab === 'normal' && (
                  <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px', color: '#1a5f3f' }}>جاري التحميل...</div>}>
                    <MathCalculator />
                  </Suspense>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-sm-12 col-md-10">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>الآلة الحاسبة العادية</h3>
            </div>
            <div className="info-section-body">
              <p>
                <strong>الآلة الحاسبة العادية</strong> هي أداة بسيطة وفعالة تتيح لك إجراء العمليات الحسابية الأساسية بكل سهولة ودون الحاجة لتحميل أي تطبيق. يمكنك استخدامها في أي وقت ومن أي مكان عبر الإنترنت، سواء من جهاز الكمبيوتر أو الموبايل. تعتبر هذه الآلة الحاسبة مثالية لإجراء العمليات اليومية مثل الجمع والطرح والضرب والقسمة، مما يجعلها أداة ضرورية للطلاب والمهنيين الذين يحتاجون إلى حسابات سريعة ودقيقة.
              </p>
              <p>
                <strong>كيفية الاستخدام:</strong> كل ما تحتاجه هو الاتصال بالإنترنت وتصفح موقع الآلة الحاسبة. قم بإدخال الأرقام والعمليات الحسابية باستخدام الفأرة إذا كنت على جهاز الكمبيوتر، أو اللمس إذا كنت على الموبايل، وستحصل على النتيجة فورًا. بفضل تصميمها البسيط، تتيح لك الآلة الحاسبة العادية تنفيذ العمليات الحسابية بسرعة وبدون تعقيد.
              </p>
              <div>
                <strong>مميزات الآلة الحاسبة العادية:</strong>
                <ul>
                  <li>سهولة الاستخدام بواجهة بسيطة ومباشرة.</li>
                  <li>سرعة في الأداء دون الحاجة لتحميل أي تطبيقات.</li>
                  <li>توفير دقة في الحسابات الأساسية اليومية.</li>
                  <li>مجانية بالكامل، مما يجعلها متاحة للجميع في أي وقت.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>الآلة الحاسبة العلمية</h3>
            </div>
            <div className="info-section-body">
              <p>
                <strong>الآلة الحاسبة العلمية</strong> هي أداة متقدمة تقدم مجموعة واسعة من الميزات التي تتجاوز الحسابات الأساسية. توفر لك إمكانية إجراء عمليات رياضية معقدة مثل حساب النسب المئوية، الكسور، الدوال الأسية، اللوغاريتمات، وحسابات المثلثات والإحصاء. تعد هذه الآلة الحاسبة مثالية للطلاب في المستويات التعليمية العليا، المهندسين، والعلماء الذين يحتاجون إلى أدوات حسابية متقدمة ودقيقة.
              </p>
              <p>
                <strong>كيفية الاستخدام:</strong> يمكنك الوصول إلى الآلة الحاسبة العلمية عبر الإنترنت، حيث توفر لك واجهة متقدمة تتيح لك إدخال المعادلات والقيام بالعمليات المعقدة. ببساطة، قم بإدخال الأرقام والمعادلات المطلوبة باستخدام أدوات الآلة الحاسبة المخصصة، وستحصل على النتائج بدقة وكفاءة.
              </p>
              <div>
                <strong>مميزات الآلة الحاسبة العلمية:</strong>
                <ul>
                  <li>وظائف متقدمة لحساب النسب المئوية، الدوال الأسية، واللوغاريتمات.</li>
                  <li>إمكانية إجراء حسابات المثلثات والإحصاء.</li>
                  <li>تصميم متقدم يتيح تنفيذ المعادلات المعقدة بسهولة.</li>
                  <li>متاحة مجانًا عبر الإنترنت، مما يوفر لك إمكانية الوصول من أي جهاز.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Calculators;